// extracted by mini-css-extract-plugin
export default {"fullWidth":"zp-z","image":"Ap-z","lazyLoadPicture":"Bp-z","lazyLoadSpinner":"Cp-z","lazyLoadSpin":"Dp-z","lazyLoadImage":"Ep-z","hasStyledAspectRatio":"Fp-z"};